export default __webpack_public_path__ + "static/media/BAH.54b55ee6.svg";